import { useStaticQuery, graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import Heading from 'app_previous/elements/typography/heading';
import Paragraph from 'app_previous/elements/typography/paragraph';
import { palette } from 'app_previous/styles/colors';
import { IStaticContentfulImages } from 'src/types/contentful';
import {
  JoinMightyCommunityBannerBackgroundContainer,
  JoinMightyCommunityBannerContainer,
  TextBlock,
  ImageBlock,
  ImageContainer,
  LinkWrapper,
} from './JoinMightyCommunityBanner.styles';
import LinkBranded from 'app_previous/elements/links/2023_Q4/LinkBranded';

const JoinMightyCommunityBanner = (): JSX.Element => {
  const { mightyCommunityScreenShot } = useStaticQuery<IStaticContentfulImages>(graphql`
    {
      mightyCommunityScreenShot: contentfulAsset(contentful_id: { eq: "5uRxOblSJNkvISPOOwWJRL" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 1200)
      }
    }
  `);

  return (
    <JoinMightyCommunityBannerBackgroundContainer>
      <JoinMightyCommunityBannerContainer>
        <TextBlock>
          <Heading
            text='Join Mighty Community'
            standardSize='2.5'
            color={palette.white}
            align='left'
          />
          <Paragraph
            text="Learn the principles of Community Design™ (and see them in action) alongside thousands of creators and entrepreneurs. It's free to join!"
            standardSize='1.5'
            color={palette.white}
            align='left'
          />
          <LinkWrapper>
            <LinkBranded
              text='Join Now'
              standardSize='1'
              url='https://community.mightynetworks.com/?utm_source=website&utm_medium=resources&utm_campaign=join_mc_resources'
              colorScheme='LightTeal'
            />
          </LinkWrapper>
        </TextBlock>
        <ImageBlock>
          <ImageContainer>
            <GatsbyImage
              image={mightyCommunityScreenShot.gatsbyImageData}
              alt='screenshot'
            />
          </ImageContainer>
        </ImageBlock>
      </JoinMightyCommunityBannerContainer>
    </JoinMightyCommunityBannerBackgroundContainer>
  );
};

export default JoinMightyCommunityBanner;
